import { StoreDiffRowEntity, BaseResponse, ListResponse } from '../../types/base.dto';
import { OrderData } from '../../types/process/order-data';
import {
  TrafficQualityTrendRowEntity,
  TrafficQualityTrendStatsEntity,
  StoreTrafficOverviewResponseEntity,
} from '../../types/entity/traffic-quality';
import apiClient from '../apiClient';
// 拆分：趋势列表与趋势统计分别返回

export interface TrafficQualityQuery {
  filter?: {
    order?: Record<string, any>;
    append?: {
      period?: string;
      key?: string;
    }
  }
}

export const trafficQualityService = {
  // // 获取流量质量数据
  // /** @deprecated 请使用 getTrafficQualityTrend */
  // getTrafficQuality: async (params: any = {}): Promise<any> => {
  //   const response = await apiClient.get<BaseResponse<any>>('/traffic-quality', {
  //     params,
  //     timeout: 600000,
  //   });
  //   return response.data.data;
  // },
  // 趋势列表（仅 rows）
  getTrafficQualityTrendRows: async (params: TrafficQualityQuery = {}): Promise<TrafficQualityTrendRowEntity[]> => {
    const response = await apiClient.post<BaseResponse<TrafficQualityTrendRowEntity[] >>('/traffic-quality/trend', params, {
      timeout: 600000,
    });
    return response.data.data;
  },
  // 趋势统计（仅 stats）
  getTrafficQualityTrendStats: async (params: TrafficQualityQuery = {}): Promise<TrafficQualityTrendStatsEntity> => {
    const response = await apiClient.post<BaseResponse<TrafficQualityTrendStatsEntity>>('/traffic-quality/stats', params, {
      timeout: 600000,
    });
    return response.data.data;
  },
  // 店铺单值对比
  getTrafficQualityCompare: async (params: TrafficQualityQuery = {}): Promise<StoreDiffRowEntity[]> => {
    const response = await apiClient.post<BaseResponse<StoreDiffRowEntity[]>>('/traffic-quality/compare', params, {
      timeout: 600000,
    });
    return response.data.data;
  },
  // 店铺流量概览
  getStoreTrafficOverview: async (params: any = {}): Promise<StoreTrafficOverviewResponseEntity> => {
    const response = await apiClient.post<BaseResponse<StoreTrafficOverviewResponseEntity>>('/traffic-quality/store-overview', params, {
      timeout: 600000,
    });
    return response.data.data;
  },
};
